export default __webpack_public_path__ + "assets/images/dashboard-admin.png";